import { AxiosInstance } from 'axios';
import axiosClient from './axiosClientConfig';
import { ApprovePhase, StepStatusCaseData } from '@/interfaces';
import { HttpResponse } from 'interfaces/httpClient';
import { getValidCaseId } from '@/utils';

class AuditService {
	constructor(private client: AxiosInstance) {}

	async getStepStatus(
		caseId: string
	): Promise<HttpResponse<StepStatusCaseData>> {
		const validCaseId = getValidCaseId(caseId);
		if (!validCaseId) {
			throw new Error('caseId is required to fetch step status');
		}
		return this.client.get(`/audit/${validCaseId}/steps-status`);
	}

	async patchMoveToTheNextPhase(caseId: string) {
		return this.client.patch(`/audit/move-to-next-phase`, { caseId });
	}
	async patchGoLive(case_id: string) {
		return this.client.patch(`/audit/${case_id}/live`);
	}
	async patchCloseStatus(case_id: string) {
		return this.client.patch(`/audit/${case_id}/close-status`);
	}
	async patchIntakeStatus(case_id: string, isOpen: boolean) {
		return this.client.patch(`/audit/${case_id}/intake-status`, { isOpen });
	}
	async postApprovePhase(
		data: ApprovePhase
	): Promise<HttpResponse<StepStatusCaseData>> {
		return this.client.post(`/audit/approves-step`, data);
	}
}

export const auditService = new AuditService(axiosClient);
